import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { CrcModel } from "./shared/models/crc.model";
import { CrcService } from "./shared/services/crc.service";
import { DataService } from "./shared/services/data.service";
import { ConfigManagerService } from "./shared/services/config-manager.service";
import { take } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  loading = true;
  config: CrcModel;

  exibirApp = false;
  exibirErro = false;
  carregando = true;

  constructor(
    public router: Router,
    public dataService: DataService,
    public crcService: CrcService,
    private configManagerService: ConfigManagerService
  ) {}

  async ngOnInit() {
    try {
      this.carregando = true;

      const config = await this.configManagerService
        .obterConfigObservable()
        .pipe(take(1))
        .toPromise();

      if (!config) {
        this.disparaErro();
        return;
      }

      this.exibirApp = true;

      await this.buscarUrl();

    } catch (error) {
      this.disparaErro();
    } finally {
      this.carregando = false; 
    }
  }

  private buscarUrl(): Promise<void> {
    return new Promise((resolve, reject) => {
      const url = window.location.origin + window.location.pathname;
      this.crcService.BuscaCrc(url).subscribe(
        (result) => {
          this.dataService.setConfig(result);
          this.loading = false;
          resolve();
        },
        (err) => {
          console.error(`Ocorreu um erro ao buscar informações, ${err}`);
          this.loading = false;
          reject(err); 
        }
      );
    });
  }

  disparaErro(): void {
    this.exibirErro = true;
    throw new Error("Erro ao obter as configurações");
  }
}
